import React, { Fragment } from "react";
import { InputLabel, Grid, Button } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";
import numberFormatter from "utils/numberFormatter";
import numeral from "numeral";
import _ from "lodash";

import { Divider, HeaderSection, SectionTitle, SelectedListItem, UnSelectedListItem,
  LabelContainerBold, DetailsCashFlowContainer,
  StyledActionButton, StyledLinkButton, VerticalDivider, SelectedNoItemGrid, GridValue } from "./styles";

export const ListItemLink = ({ isSelected, item, title, handleClick }) => {
  const children = (<div>{title || "Provider Selection Needed"}</div>);

  return isSelected ?
    (<SelectedListItem onClick={() => handleClick(item)}>{children}</SelectedListItem>) :
    (<UnSelectedListItem onClick={() => handleClick(item)}>{children}</UnSelectedListItem>);
};

const GridItemDuo = ({ label, value }) => (
  <Grid container item xs={12} alignItems="center">
    <Grid item xs={5}>
      <LabelContainerBold>{label}</LabelContainerBold>
    </Grid>
    <Grid item xs={6}>
      <GridValue name={`hedgeValueFor${label}`}>
        {value}
      </GridValue>
    </Grid>
  </Grid>
);

export const DateItem = ({ value, label }) => <GridItem value={value} label={label} mask="date" />;
export const CurrencyItem = ({ value, label }) => <GridItem value={value} label={label} mask="currency" />;
export const PercentItem = ({ value, label }) => <GridItem value={value} label={label} mask="percent" />;
export const PercentNoDecimalItem = ({ value, label }) => <GridItem value={value} label={label} mask="percentNoDecimal" />;
export const DscrItem = ({ value, label }) => <GridItem value={value} label={label} mask="dscr" />;
export const TextItem = ({ value, label }) => <GridItem value={value} label={label} mask="text" />;
export const CreditChargeItem = ({ value, label }) =>
  // NOTE: for some reason this is not saved as the real value in bps, but rather its display value.
  (
    <GridItemDuo label={label} value={(value)} />
  );

export const GridItem = ({ mask, value, label }) => {
  function formatValue(key, value) {
    if (!value && value !== 0) {
      return "-";
    }
    switch (key) {
      case "date":
        return moment.utc(value).format("MM/DD/YYYY");
      case "currency":
        return numberFormatter.maskCurrency(value);
      case "percent":
        return numberFormatter.formatRate(value / 100, 2);
      case "percentNoDecimal":
        return numberFormatter.formatRate(value / 100, 0);
      case "dscr":
        return `${value}x`;
      default:
        return value;
    }
  }

  return <GridItemDuo label={label} value={formatValue(mask, value)} />;
};

export const ViewHeader = ({ TitleText, children }) => (<>
  <Divider>
    <hr />
  </Divider>
  <HeaderSection container>
    <Grid item xs={6} sm={6} md={6}>
      <SectionTitle className="title-component">
        {TitleText}
        {children}
      </SectionTitle>
    </Grid>
  </HeaderSection>
  {" "}
                                                        </>);

// NOTE: I Hate whoever created this, use loops for the love of god!
export const ItemLinks = ({
  DetailsLink
  , CashflowsLink
  , Link
  , shouldShowCashflowsLink
  , itemName
  , shouldShowEscrowLedgerLink
  , escrowLedgerLink
}) => (<Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
  <Grid item xs={7} />
  <Grid item xs={5}>
    <DetailsCashFlowContainer container direction="row" justify="flex-start" alignItems="center" spacing={0}>
      <Grid>
        <StyledActionButton variant="contained" name={`buttonForDetails${itemName}`} component={Link} to={DetailsLink}>DETAILS</StyledActionButton>
      </Grid>
      {shouldShowCashflowsLink && (
        <>
          <Grid item><VerticalDivider /></Grid>
          <Grid item>
            <StyledActionButton variant="contained" name={`buttonForCashFlows${itemName}`} component={Link} to={CashflowsLink}>CASHFLOWS</StyledActionButton>
          </Grid>
        </>)}

      {shouldShowEscrowLedgerLink && (
        <>
          <Grid item><VerticalDivider /></Grid>
          <Grid item>
            <StyledActionButton variant="contained" name={`buttonForEscrowLedger${itemName}`} component={Link} to={escrowLedgerLink}>ESCROW LEDGER</StyledActionButton>
          </Grid>
        </>)}
    </DetailsCashFlowContainer>
  </Grid>
</Grid>);

export const DeadItemLinks = ({ DetailsLink, CashflowsLink, Link }) => ItemLinks(DetailsLink, CashflowsLink);

export const NoItems = ({ Message }) => (<Grid container direction="row" justify="flex-start" alignItems="center" spacing={8} style={{ paddingBottom: "8px" }}>
  <SelectedNoItemGrid container item>{Message}</SelectedNoItemGrid>
                                         </Grid>);

export const getMinValue = (list, field) => {
  if ((!list || !field) || list.length === 0) {
    return null;
  }
  const mappedFields = list.map(x => _.get(x, field));

  return _.min(mappedFields);
};

export const getExtensionTriggers = (ltvReq, dscrReq, debtYieldReq) => `${ltvReq || "--"} | ${dscrReq || "--"} | ${debtYieldReq || "--"}`;

export const makePercent = num => {
  if (num) {
    return numeral(num).format("0.00%");
  }
};

export const makeDSCR = num => {
  if (num) {
    return `${num}x`;
  }
};

export const getListItemLink = (loan, selectedLoan, handleSelect) => {
  const lenderCompany = _.get(loan, "lenderCompany.name") ? _.get(loan, "lenderCompany.name") : "Lender Selection Needed";
  const loanSeniority = _.get(loan, "loanSeniority.value") ? ` - ${_.get(loan, "loanSeniority.value")}` : "";
  const formattedClosingDate = _.get(loan, "closingDate") ? ` - ${moment.utc(_.get(loan, "closingDate")).format("YYYY")}` : "";

  return (<ListItemLink
    key={loan.id}
    isSelected={selectedLoan.id == loan.id}
    loan={loan}
    title={`${lenderCompany}${loanSeniority}${formattedClosingDate}`}
    handleClick={() => handleSelect(loan)}
  />);
};
